import { c as _c } from "react/compiler-runtime";
import { CampaignStepSingle } from 'modules/campaigns/campaign-step-single';
import { CampaignStepEditorLoco } from 'modules/campaigns/campaign-steps/constants/campaign-step-editor-loco';
import { useCampaignStepData } from 'modules/campaigns/campaign-steps/hooks/use-campaign-step-data';
import { CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Loader } from 'shared/components/loader';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const CampaignStepEdit: NextPage = () => {
  const $ = _c(7);
  const router = useRouter();
  const campaignId = Number(router.query.campaignId) as CampaignId | undefined;
  const campaignStepId = Number(router.query.campaignStepId) as CampaignStepId | undefined;
  let t0;
  if ($[0] !== campaignStepId) {
    t0 = {
      campaignStepId
    };
    $[0] = campaignStepId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    campaignStepData
  } = useCampaignStepData(t0);
  const isReady = typeof campaignId === "number" && typeof campaignStepId === "number" && !!campaignStepData;
  let t1;
  if ($[2] !== campaignId || $[3] !== campaignStepData || $[4] !== campaignStepId || $[5] !== isReady) {
    t1 = isReady ? <CampaignStepSingle campaignId={campaignId} campaignStepId={campaignStepId} campaignStepData={campaignStepData} /> : <div className="flex h-full items-center justify-center"><Loader type="dark" /></div>;
    $[2] = campaignId;
    $[3] = campaignStepData;
    $[4] = campaignStepId;
    $[5] = isReady;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export const getServerSideProps = getBaseServerSideProps(CampaignStepEditorLoco, 'header.top_menu.campaigns');
export default CampaignStepEdit;